import {DiaryActionType} from "../../reducers/diaryReducer/types";
import {Dispatch} from "redux";
import {AddDiaryAsync, DeleteDiaryAsync, GetDiaryAsync} from "../../../services/api-diary-service";

export const GetDiary = (date: string) => {
    return async (dispatch: Dispatch) => {
        dispatch({type: DiaryActionType.START_REQUEST});
        const data = await GetDiaryAsync(date);
        const {response} = data;
        dispatch({
            type: DiaryActionType.DIARY_LOADED,
            payload: response,
        });
    }
}

export const AddDiary = (diary: any) => {
    return async (dispatch: Dispatch) => {
        dispatch({type: DiaryActionType.START_REQUEST});
        const data = await AddDiaryAsync(diary);
        const {response} = data;
        dispatch({
            type: DiaryActionType.FINISH_REQUEST,
            payload: response,
        });
    }
}

export const DeleteDiary = (id: number) => {
    return async (dispatch: Dispatch) => {
        dispatch({type: DiaryActionType.START_REQUEST});
        const data = await DeleteDiaryAsync(id);
        const {response} = data;
        dispatch({
            type: DiaryActionType.FINISH_REQUEST,
            payload: response,
        });
    }
}